export const pNgLicenseKey =
  '1hnUUR/IIYWZS00f8DEzldKj6WNwKThGzzRe+j0eEST29fpkQuRHa7ITxp5uMucc9AGJ89M+Fl8tdPBf46cgvtya3Bmi1+GXkeE3m413AVE1oYZI/BrBSnOMV0NM5PGS';
export const pNgPassKey = '01kre3spmkp621kcp6gq492awj';